import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Tooltip } from '@mui/material';
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { getModuleList, publishCourse } from "../../services/courseServices";
import { CommanTableContain, StyledButton } from "../../style/table";
import { ExamCreationListContainer } from "../../style/Admin/ExamCreationContainer";
import PublishModel from "../../components/utils/PublishModel";
import ReadMore from "../../components/ReadMore";
import { Colors } from "../../style/theme/index.js";
import DashboardHeader from "../../components/Common/DashboardHeader";


function ExamCreationList() {
  const location = useLocation();
  const { courseId, courseStatus } = location.state;
  const [rows, setRows] = useState([]);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [disable, setDisable] = useState(courseStatus === "published" ? true : false);

  useEffect(() => {
    fetchModules();
  }, [courseId]);

  const fetchModules = async () => {
    try {
      const response = await getModuleList(courseId);
      if (response.success) {
        setRows(response?.modules ?? []);
      }
    } catch (error) {
      toast.warning("No Module Found");
    }
  };

  const handlePublishCourse = () => {
    const firstEmptyModule = rows.find((module) => module.questionCount === 0);

    if (firstEmptyModule) {
      toast.warning(`Module "${firstEmptyModule.name}" has no questions. Please add questions before publishing.`);
      return;
    }

    setOpenPublishModal(true);
  };

  const handlePublishConfirm = async () => {
    try {
      await publishCourse(courseId, { status: "published" });
      toast.success("Course published successfully!");
      setDisable(true);
    } catch (error) {
      toast.error("Error publishing course!");
    }
    setOpenPublishModal(false);
    setDisable(true);
  };


  return (
    <>
      <ToastContainer />
      <ExamCreationListContainer>
        <DashboardHeader title="Exam Creation List" />
        <CommanTableContain className="exam-list">
          <Table stickyHeader>
            <TableHead className="table-header">
              <TableRow>
                <TableCell>Module Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Questions</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((module, index) => (
                <TableRow key={index}>
                  <TableCell>{module.name}</TableCell>
                  <TableCell className="discription"><ReadMore length={30}>{module.description}</ReadMore></TableCell>
                  <TableCell>{module.questionCount}</TableCell>
                  <TableCell className="action-button">
                    <Link className="actionIcon" to="/exam-creation" state={{ courseId, moduleId: module.id, moduleName: module.name }}>
                      <AddCircleOutlineOutlinedIcon />
                    </Link>
                    {module.questionCount > 0 && (<Link className="actionIcon" to="/exam" state={{ courseId: courseId, moduleId: module.id }}>
                      <Tooltip title="Preview from user side" arrow>
                         <RemoveRedEyeOutlinedIcon />
                      </Tooltip>
                    </Link>)}                    
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CommanTableContain>

        <StyledButton className="publish-btn" onClick={handlePublishCourse} disabled={disable}>
          Publish Course
        </StyledButton>
      </ExamCreationListContainer>
      <PublishModel open={openPublishModal} handleCancel={() => {setOpenPublishModal(false)}} handleConfirm={handlePublishConfirm} />
    </>
  );
}

export default ExamCreationList;
